import { render, staticRenderFns } from "./PreCompetencyTab.vue?vue&type=template&id=8a896b2a&scoped=true"
import script from "./PreCompetencyTab.vue?vue&type=script&lang=js"
export * from "./PreCompetencyTab.vue?vue&type=script&lang=js"
import style0 from "./PreCompetencyTab.vue?vue&type=style&index=0&id=8a896b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a896b2a",
  null
  
)

export default component.exports